import styled from 'styled-components';

export const TimeInput = styled.input.attrs({type : "time"})`
    &::-webkit-calendar-picker-indicator {
        display: none;
    }
`;